import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Typography, Breadcrumb, Space, Divider, Grid, Collapse, Card } from 'antd';
import { sponsorshipContent2026 } from './content';
// import Proposal from '../../assets/doc/Proposal.pdf';

const { Text } = Typography;
const { Panel } = Collapse;
const { useBreakpoint } = Grid;

function Sponsorship() {
  const { xs } = useBreakpoint()
  const categories = Array.isArray(sponsorshipContent2026?.categories)
    ? sponsorshipContent2026.categories
    : [];

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <React.Fragment>
      <Row className='content-body' justify="space-around" align="middle" gutter={32} style={{ backgroundColor: '#fff', paddingBottom: 0 }}>
        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Breadcrumb style={{ marginTop: xs ? 16 : -16 }}>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Sponsorship</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={xs ? 16 : 32}>
            <Space direction="vertical" style={{ width: '100%', textAlign: 'center' }}>
              <Text style={{ fontSize: 25, fontWeight: 'bold' }}>Sponsorship</Text>
              <Text style={{ fontSize: 23, color: '#373737' }}>Why Sponsor?</Text>
            </Space>
            <Space direction="vertical" size={16}>
              <Text style={{ fontSize: 15 }}>The Third World Conference on Health and Social Science (WCHSS III) welcomes collaboration with institutions, organizations, companies, and partners who are committed to advancing health and social science innovation across the human life cycle.</Text>
              <Text style={{ fontSize: 15 }}>By becoming a sponsor, organizations will gain opportunities to:</Text>
              <ul style={{ marginLeft: -24 }}>
                <li><Text style={{ fontSize: 16 }}>increase brand visibility among academics, researchers, healthcare professionals, policymakers, and students;</Text></li>
                <li><Text style={{ fontSize: 16 }}>establish strategic partnerships and professional networking opportunities;</Text></li>
                <li><Text style={{ fontSize: 16 }}>support interdisciplinary scientific discussions and research dissemination;</Text></li>
                <li><Text style={{ fontSize: 16 }}>promote products, services, and institutional initiatives to an international audience;</Text></li>
                <li><Text style={{ fontSize: 16 }}>strengthen commitment toward health, education, and social development.</Text></li>
              </ul>
              <Text style={{ fontSize: 15 }}>WCHSS 2026 offers various sponsorship opportunities tailored to support meaningful engagement and maximize sponsor exposure throughout the conference activities.</Text>
            </Space>
          </Space>
        </Col>
        <Col span={24} style={{ marginTop: xs ? 0 : 32, marginBottom: xs ? 0 : 32 }}>
          <Divider />
        </Col>
        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Space direction="vertical" size={xs ? 16 : 32} style={{ width: '100%' }}>
            <Space direction="vertical" style={{ width: '100%', textAlign: 'center' }}>
              <Text style={{ fontSize: 25, fontWeight: 'bold' }}>Sponsorship Categories</Text>
            </Space>
          </Space>
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={xs ? 8 : 32} style={{ width: '100%' }}>
            {categories.map((category, index) => (
              <Space key={`${category.title}-${index}`} direction="vertical" size={0} style={{ width: '100%' }}>
                <Text style={{ fontSize: 23, fontWeight: 'bold', color: '#E5BB66' }}>{category.title}</Text>
                {category.price ? (
                  <Text style={{ fontSize: 23, fontWeight: 'bold', color: '#0F6F4B' }}>{category.price}</Text>
                ) : null}
                <Collapse className="collapse-sponsorship" bordered={false} ghost defaultActiveKey={['benefits']} style={{ marginLeft: -16 }}>
                  <Panel header={<Text style={{ fontSize: 23, fontWeight: 'bold' }}>Benefits</Text>} key="benefits">
                    <ul style={{ marginLeft: -24 }}>
                      {(category.benefits || []).map((benefit, benefitIndex) => (
                        <li key={`${index}-${benefitIndex}`}><Text style={{ fontSize: 16 }}>{benefit}</Text></li>
                      ))}
                    </ul>
                  </Panel>
                </Collapse>
              </Space>
            ))}
          </Space>
        </Col>
        <Col span={24} style={{ marginTop: xs ? 0 : 32, marginBottom: xs ? 0 : 32 }}>
          <Divider />
        </Col>
        <Col span={24}>
          <Space direction="vertical" style={{ width: '100%', textAlign: 'center', marginBottom: 16 }}>
            <Text style={{ fontSize: 25, fontWeight: 'bold' }}>Packages</Text>
          </Space>
          <Card style={{ width: '100%', backgroundColor: '#e8ebed', borderRadius: 12, boxShadow: '0 2px 8px 1px #f1f3f4' }}>
            <Row justify="space-around" align="middle" gutter={[0,8]} style={{ textAlign: 'center', marginBottom: xs ? 16 : 32 }}>
              <Col span={24}>
                <Space direction='vertical' size={0} style={{ fontWeight: 500 }}>
                  <Text style={{ fontSize: 23 }}>Additional Opportunities</Text>
                </Space>
              </Col>
            </Row>
            <Row justify="space-around" align="middle" gutter={xs ? 16 : 32}>
              <Col xs={24} lg={12}>
                <Space direction="vertical" size={16}>
                  {
                    xs ? 
                      <Space direction='vertical' size={0}>
                        <Text style={{ fontSize: 15 }}>Cultural Dinner Sponsor</Text>
                        <Text style={{ fontSize: 20, color: '#0F6F4B' }}>IDR 25.000.000</Text>
                      </Space>
                    :
                      <Space>
                        <Text style={{ fontSize: 15 }}>Cultural Dinner Sponsor |</Text>
                        <Text style={{ fontSize: 20, color: '#0F6F4B' }}>IDR 25.000.000</Text>
                      </Space>
                  }
                  <ul style={{ marginLeft: -24 }}>
                    <li><Text style={{ fontSize: 16 }}>Logo placement during cultural dinner</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Recognition during dinner session</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Sponsor branding exposure in event documentation</Text></li>
                  </ul>
                </Space>
              </Col>
              <Col xs={24} lg={12}>
                <Space direction="vertical" size={16}>
                  {
                    xs ? 
                      <Space direction='vertical' size={0}>
                        <Text style={{ fontSize: 15 }}>Seminar Kit Sponsor</Text>
                        <Text style={{ fontSize: 20, color: '#0F6F4B' }}>IDR 25.000.000</Text>
                      </Space>
                    :
                      <Space>
                        <Text style={{ fontSize: 15 }}>Seminar Kit Sponsor |</Text>
                        <Text style={{ fontSize: 20, color: '#0F6F4B' }}>IDR 25.000.000</Text>
                      </Space>
                  }
                  <ul style={{ marginLeft: -24 }}>
                    <li><Text style={{ fontSize: 16 }}>Logo placement on seminar kits</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Branding visibility throughout conference sessions</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Sponsor recognition on conference media</Text></li>
                  </ul>
                </Space>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={24} style={{ marginTop: 16 }}>
          <Space direction='vertical'>
            <Text style={{ fontSize: 23, fontWeight: 500 }}>Co-partnership</Text>
            <Space direction='vertical' size={0}>
              <Text style={{ fontSize: 16 }}>Additional collaboration opportunities may include publications, media partnerships, educational collaboration, community engagement, and institutional partnerships.</Text>
            </Space>
          </Space>
        </Col>
        <Col span={24} style={{ marginTop: xs ? 0 : 32, marginBottom: xs ? 0 : 32 }}>
          <Divider />
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={xs ? 16 : 32}>
            <Space direction="vertical" style={{ width: '100%', textAlign: 'center' }}>
              <Text style={{ fontSize: 25, fontWeight: 'bold' }}>Payment & Conditions</Text>
            </Space>
            <Space direction="vertical" size={xs ? 16 : 32}>
              <ul style={{ marginLeft: -24 }}>
                <li><Text style={{ fontSize: 16 }}>All sponsorship prices are listed in Indonesian Rupiah (IDR).</Text></li>
                <li><Text style={{ fontSize: 16 }}>Sponsorship payments must be completed according to the agreement timeline.</Text></li>
                <li><Text style={{ fontSize: 16 }}>Sponsors are responsible for providing promotional materials before the event deadline.</Text></li>
                <li><Text style={{ fontSize: 16 }}>Sponsorship packages may be adjusted based on mutual agreement between the sponsor and organizing committee.</Text></li>
                <li><Text style={{ fontSize: 16 }}>All sponsorship collaborations will be confirmed through official agreements.</Text></li>
              </ul>
              <Space direction='vertical'>
                <Text style={{ fontSize: 23, fontWeight: 'bold' }}>Sponsors’ responsibilities</Text>
                <Text style={{ fontSize: 16 }}>Sponsors are responsible for submitting all required branding and promotional materials within the timeline determined by the organizing committee.</Text>
              </Space>
              <Space direction='vertical'>
                <Text style={{ fontSize: 23, fontWeight: 'bold' }}>Sponsor agreements</Text>
                <Text style={{ fontSize: 16 }}>All sponsorship collaborations will be formalized through an official agreement signed by both parties.</Text>
              </Space>
              <Space direction='vertical'>
                <Text style={{ fontSize: 23, fontWeight: 'bold' }}>Sponsorship cancellation policy</Text>
                <Text style={{ fontSize: 16 }}>Any sponsorship cancellation must be submitted formally in writing and may be subject to agreement terms and conditions.</Text>
              </Space>
              <Space direction='vertical'>
                <Text style={{ fontSize: 23, fontWeight: 'bold' }}>Disclaimer</Text>
                <Space direction='vertical' size={0}>
                  <Text style={{ fontSize: 16 }}>The organizing committee reserves the right to adjust sponsorship arrangements, publication formats, and promotional activities depending on conference conditions and operational considerations.</Text>
                </Space>
              </Space>
            </Space>
          </Space>
        </Col>
        {/* {
          xs ?
            <Col span={24} style={{ textAlign: 'center', marginTop: 16 }}>
              <Space direction='vertical'>
                  <Text>Click Here to</Text>
                  <Link to={Proposal} target="_blank" download>
                    <Button className='button-green'>Download here</Button>
                  </Link>
              </Space>
            </Col>
          :
            <Col span={24} style={{ float: 'right' }}>
              <Space style={{ float: 'right' }}>
                  <Text>Click Here to</Text>
                  <Link to={Proposal} target="_blank" download>
                    <Button className='button-green'>Download here</Button>
                  </Link>
              </Space>
            </Col>
        } */}
        
      </Row>
    </React.Fragment>
  )
}

export default Sponsorship